




































































































































































































































































import { Component, Vue, Watch, Provide } from "vue-property-decorator";
import { ticketClient, authorClient } from "@/api/index";
import { setCommon, errorMsg, setPage, handleResponse } from "@/utils/request";
import {
  GetTicketRecycleRulesReq,
  SaveTicketRecycleRuleReq,
  TicketRecycleRuleAttr,
  GetTicketAttrsOptionReq,
  GetUserAttrsOptionReq,
  GetTicketRecycleParamReq
} from "@/pbjs/external/ticket/ticket_pb";
import { timeFormat, addZero, arrRemove } from "@/utils/index";
import { pagnition } from "@/utils/commonConfig";

@Component({
  name: "CombinationProperty"
})
export default class CombinationProperty extends Vue {
  @Provide() private token: any;
  @Provide() private userId: number | null = null;
  @Provide() private resultData: any = [];
  @Provide() private sortticketList: any = [];
  @Provide() private WorkModeOptions: any = [];
  @Provide() private loadAttrList: any = [];
  @Provide() private combOptions: any = [];
  @Provide() private pageIndex: number = 1;
  @Provide() private pageSize: number = 20;
  @Provide() private pagerCount: number = 0;
  @Provide() private isEditName: boolean = false;
  @Provide() private isEditId: number = 0;
  @Provide() private thirdcompanyList: any = [];
  @Provide() private roleGroupList: any = [];
  @Provide() private form: any = {
    moment: null,
    ticketType: null,
    name: "",
    roleGroupValue: null,
    staffAttrsValue: null,
    actionValue: null,
    WorkDay: "",
    period: [new Date(2020, 6, 1, 0, 0), new Date(2020, 6, 1, 23, 59)]
  };
  @Provide() private pagnition: any = pagnition;
  @Provide() private staffAttrsOptions: any = [];
  @Provide() private timeOptions: string[] = ["时间点", "时间段"];
  @Provide() private showTimeType: string = "";
  @Provide() private actionOptions: any = [];

  private handleCurrentChange(val: any) {
    this.pageIndex = Number(val);
    //展示表格数据
    this.getTicketRecycleRules();
  }

  //点击上一页
  private handlePrevChange(val: any) {
    if (this.pageIndex > 0) {
      //展示表格数据
      this.getTicketRecycleRules();
    }
  }

  //点击下一页
  private handleNextChange(val: any) {
    //展示表格数据
    this.getTicketRecycleRules();
  }

  private handleSizeChange(val: any) {
    this.pageSize = Number(val);
    //展示表格数据
    this.getTicketRecycleRules();
  }

  private created() {
    this.token = localStorage.getItem("token");
    this.userId = Number(localStorage.getItem("userid"));
    this.getTicketAttrsOption();
    this.getTicketRecycleRules();
    this.listRole();
    this.getUserAttrsOption();
    this.getTicketRecycleParam();
  }

  private editName() {
    this.isEditName = true;
  }

  private resetForm() {
    this.showTimeType = "";
    this.form = {
      moment: null,
      ticketType: null,
      name: "",
      WorkDay: "",
      roleGroupValue: null,
      staffAttrsValue: null,
      period: [new Date(2020, 6, 1, 0, 0), new Date(2020, 6, 1, 23, 59)]
    };
  }

  private editRecycleItem(row: any) {
    this.resetForm();
    this.isEditId = row.id;
    this.isEditName = true;
    this.form = {
      moment: null,
      ticketType: row.attrs.ticketattrList,
      name: row.attrs.name,
      WorkDay: row.attrs.workday,
      roleGroupValue: row.attrs.adminattrList,
      staffAttrsValue: row.attrs.userattrList,
      period: [new Date(2020, 6, 1, 0, 0), new Date(2020, 6, 1, 23, 59)]
    };
    if (row.attrs.tasktime) {
      this.showTimeType = "时间点";
      this.form.moment = this.getTaskTime(row.attrs.tasktime);
    }
    if (row.attrs.begintime) {
      this.showTimeType = "时间段";
      let start = row.attrs.begintime.split(":");
      let end = row.attrs.endtime.split(":");
      this.form.period = [
        new Date(2020, 6, 1, Number(start[0]), Number(start[1])),
        new Date(2020, 6, 1, Number(end[0]), Number(end[1]))
      ];
      if (row.attrs.timeaction) {
        this.form.actionValue = row.attrs.timeaction + "";
      }
    }
  }
  // 停用、启用
  private stopOrStartAssignRuleAction(id: number, action: number) {
    this.dwAssignRule({
      id: Number(id),
      action: Number(action)
    });
  }
  // 删除
  private deleteAssignRuleAction(id: number) {
    this.dwAssignRule({
      id: Number(id),
      action: 3
    });
  }
  // 启用停用和删除工用的处理参数、请求的函数
  private async dwAssignRule(options: any) {
    interface IDeleteTicketRecycleRuleReqOptions {
      id: number;
      action: number;
    }
    let _arg: IDeleteTicketRecycleRuleReqOptions = {
      id: Number(options.id),
      action: Number(options.action)
    };
    const { deleteTicketRecycleRule }: any = await import(
      "@/request/deleteTicketRecycleRule"
    );
    let response = await deleteTicketRecycleRule(_arg, this);
    if (response && response.commonout) {
      if (response.commonout.code == 0) {
        this.$message({
          message: "success",
          type: "success"
        });
        if (options.action == 3) {
          let _item = this.resultData.find((item: any) => {
            if (item.id == options.id) {
              return item;
            }
          });
          arrRemove(this.resultData, _item);
        } else {
          this.resultData = this.resultData.map((item: any) => {
            // if(item.id == options.id) {
            // }
            item.attrs.workstatus =
              item.id == options.id
                ? item.attrs.workstatus == 1
                  ? 0
                  : 1
                : item.attrs.workstatus;
            return item;
          });
        }
      } else {
        this.$message({
          message: response.commonout.errmsg,
          type: "error"
        });
      }
    }
  }
  private formatTime(time: Date | null): any {
    if (time) {
      if (typeof time === "number") {
        time = new Date(time);
      }
      return addZero(time.getHours()) + ":" + addZero(time.getMinutes());
    } else {
      return time;
    }
  }

  private getTaskTime(time: string | null) {
    if (time) {
      let timeArr = time.split(":");
      return new Date(2020, 6, 1, Number(timeArr[0]), Number(timeArr[1]));
    } else {
      return null;
    }
  }

  private listRole() {
    let request: any = setCommon();
    authorClient.listRole(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (data.commonout) {
          if (data.commonout.code == 0) {
            this.roleGroupList = data.roletreeList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        } else {
          if (data.code == 0) {
            this.roleGroupList = data.roletreeList;
          } else {
            this.$message.error(data.errmsg);
          }
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }

  private getTicketAttrsOption() {
    let request: any = new GetTicketAttrsOptionReq();
    request.setCommonin(setCommon());
    ticketClient.getTicketAttrsOption(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (data.commonout) {
            if (data.commonout.code == 0) {
              this.combOptions = data.listList;
            } else {
              this.$message.error(data.commonout.errmsg);
            }
          } else {
            if (data.code == 0) {
              this.combOptions = data.listList;
            } else {
              this.$message.error(data.errmsg);
            }
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private getTicketRecycleRules() {
    let request: any = new GetTicketRecycleRulesReq();
    request.setCommonin(setCommon());
    request.setPagein(setPage(this.pageIndex, this.pageSize));
    ticketClient.getTicketRecycleRules(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (!data.commonout || data.commonout.code == 0) {
            this.pagerCount = data.pageout.total;
            data.listList.forEach((item: any) => {
              item.newTime = timeFormat(item.ctime);
            });
            this.resultData = data.listList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private saveTicketRecycleRule() {
    let request: any = new SaveTicketRecycleRuleReq();
    let saveItem: any = new TicketRecycleRuleAttr();
    saveItem.setTicketattrList(this.form.ticketType);
    saveItem.setAdminattrList(this.form.roleGroupValue);
    saveItem.setUserattrList(this.form.staffAttrsValue);
    saveItem.setName(this.form.name);
    saveItem.setWorkday(this.form.WorkDay);
    if (this.showTimeType == "时间点") {
      saveItem.setTasktime(this.formatTime(this.form.moment));
    }
    if (this.showTimeType == "时间段") {
      saveItem.setBegintime(
        this.form.period && this.formatTime(this.form.period[0])
      );
      saveItem.setEndtime(
        this.form.period && this.formatTime(this.form.period[1])
      );
      saveItem.setTimeaction(Number(this.form.actionValue));
    }
    request.setCommonin(setCommon());
    request.setId(this.isEditId);
    request.setData(saveItem);
    ticketClient.saveTicketRecycleRule(
      request,
      {},
      (err: any, response: any) => {
        if (response) {
          let data: any = response.toObject();
          if (!data.commonout || data.commonout.code == 0) {
            this.getTicketRecycleRules();
            this.resetForm();
            this.isEditName = false;
            this.$message({ type: "success", message: "submit successfully" });
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        }
        if (err) {
          errorMsg(err);
        }
      }
    );
  }

  private getUserAttrsOption() {
    let request: any = new GetUserAttrsOptionReq();
    request.setCommonin(setCommon());
    ticketClient.getUserAttrsOption(request, {}, (err: any, response: any) => {
      if (response) {
        let data: any = response.toObject();
        if (data.commonout) {
          if (data.commonout.code == 0) {
            this.staffAttrsOptions = data.listList;
          } else {
            this.$message.error(data.commonout.errmsg);
          }
        } else {
          if (data.code == 0) {
            this.staffAttrsOptions = data.listList;
          } else {
            this.$message.error(data.errmsg);
          }
        }
      }
      if (err) {
        errorMsg(err);
      }
    });
  }
  // lin 获取工单回收支持的所有的参数数据
  private async getTicketRecycleParam() {
    const { getTicketRecycleParam }: any = await import(
      "@/request/getTicketRecycle"
    );
    let res = await getTicketRecycleParam();
    if (res && res.param) {
      this.actionOptions = res.param.timeactionList;
      this.WorkModeOptions = res.param.workmodeList;
    }
  }
}
